import {NgModule} from '@angular/core';
import {Route, RouterModule, Routes} from '@angular/router';
import {LpSubRoutes} from './launchpad/lp.route';

export function getLaunchpadRouters(): { name: string; routeMethod: () => Routes }[] {
    return [
        {name: 'lp', routeMethod: LpSubRoutes},
    ];
}

function collectLaunchpadSubRoutes(): Route[] {
    const routes: Route[] = [];
    const launchpadRouters = getLaunchpadRouters();
    for (const router of launchpadRouters) {
        const subRoutes = router.routeMethod();
        if (subRoutes) {
            routes.push(...subRoutes);
        }
    }
    return routes;
}

const routes: Routes = [
    {
        path: '',
        children: collectLaunchpadSubRoutes(),
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class FeatureLaunchpadRoutingModule {
}
